// extracted by mini-css-extract-plugin
module.exports = {"blue":"CustomCheckbox_blue__3Uv-9"};